module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_8.49063c09.png";